import { useEffect, useState } from "react";

// Lee `prefers-reduced-motion` y se mantiene al día si el usuario cambia la
// preferencia del sistema con la pestaña abierta.
//
// El bloque global de index.css ya frena todo lo que es CSS. Este hook es para
// lo que solo se puede parar desde JavaScript: el contador animado de la
// portada y el parallax del héroe.
export default function useReducedMotion() {
  const [reduced, setReduced] = useState(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    const onChange = e => setReduced(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return reduced;
}
